//@flow
import React from 'react';

import {makeStyles, TableCell, Typography} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {useState} from 'react';
import {colors} from '../../../../../assets/styles/colors';
import TextEditor from '../../../../products/components/Sections/ProductFeaturesSection/TextEditor/TextEditor';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useProductContext} from '../../../context';
import {useEditProduct} from '../../../utils/editProduct';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '240px',

    '& input': {
      cursor: 'pointer',
    },
  },
  modalRoot: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 600,
    width: '90vw',
    gap: '1.5rem',
    overflow: 'hidden',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
    color: colors.grey800,
  },
  textEditor: {
    width: '100%',
    marginBottom: '1.5rem',
  },
  submitButton: {
    maxWidth: '240px',
    fontSize: '1.125rem',
    fontWeight: 600,
  },
}));

export default function ProductDescriptionCell() {
  const classes = useStyles();
  const [product] = useProductContext(product => ({
    id: product.id,
    description: product.description,
  }));

  const [description, setDescription] = useState(
    product && product.description ? product.description : ''
  );
  const [descriptionModalOpen, setDescriptionModalOpen] = useState(false);
  const {editProduct} = useEditProduct(product ? product.id : '');

  if (!product) return null;

  const openDescriptionModal = () => setDescriptionModalOpen(true);
  const closeDescriptionModal = () => setDescriptionModalOpen(false);

  const onSubmit = () => {
    editProduct({description});
    setDescriptionModalOpen(false);
  };

  return (
    <>
      <TableCell align="right">
        <CustomTextField
          name="description"
          className={classes.textField}
          value={description}
          type="text"
          onFocus={() => {
            window.document.activeElement.blur();
            openDescriptionModal();
          }}
        />
      </TableCell>
      <CustomModal
        open={descriptionModalOpen}
        handleCloseModal={closeDescriptionModal}
      >
        <aside className={classes.modalRoot}>
          <Typography className={classes.title} align="center">
            Descripción de Producto
          </Typography>
          <div className={classes.textEditor}>
            <TextEditor
              placeholder="Descripción de tu producto"
              text={description}
              handleDescription={setDescription}
              autoFocus
            />
          </div>
          <CustomButton
            className={classes.submitButton}
            color="primary"
            variant="contained"
            fullWidth
            onClick={onSubmit}
          >
            Guardar
          </CustomButton>
        </aside>
      </CustomModal>
    </>
  );
}
